export default __webpack_public_path__ + "static/media/appStore.fd743c35.png";